import { Api } from "../config/request";

export default {
  getRestrictedPayoutDrivers(queryParams) {
    return Api.get(
      `/driver-accounting/restricted-payout-drivers?${queryParams}`
    );
  },
};
